import { render, staticRenderFns } from "./wasteManage.vue?vue&type=template&id=e990681c&scoped=true"
import script from "./wasteManage.vue?vue&type=script&lang=js"
export * from "./wasteManage.vue?vue&type=script&lang=js"
import style0 from "./wasteManage.vue?vue&type=style&index=0&id=e990681c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e990681c",
  null
  
)

export default component.exports